module.exports = __webpack_public_path__ + "img/6e7ea2a.svg";